export default "<div  tabindex=\"-1\" class=\"map\" id=\"map\" [ngClass]=\"{'confirmation-map': confirmationPage}\">\n</div>"